export default "__VITE_ASSET__9c81e43a__"